<script lang="ts">
import { PropType, VNode, defineComponent, h } from 'vue';

import { Nullable } from '@/utils/types';
import { isValuePresent } from '@/bundles/App/helpers/isValuePresent';

export default defineComponent({
  name: 'Label',

  inheritAttrs: false,

  props: {
    value: {
      type: [String, Number, Boolean] as PropType<Nullable<string | number | boolean>>,
      default: ''
    }
  },

  render (): VNode {
    const value = this.value;

    if (!isValuePresent(value)) {
      return h('span', { ...this.$attrs, class: [this.$attrs.class, 'na'] }, 'N/A');
    }

    return h('span', { ...this.$attrs }, value);
  }
});
</script>
